import React, { useState, useEffect, useContext } from "react";

import { Box, IconButton, Paper, TableContainer, TableBody, TableCell, TableHead, TableRow, Table, Typography, Stack, Button } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { isEmpty } from "lodash";
import { DataContext } from "../../../context/DataContext";
import { isAccess, simpleMessage } from "../../../helpers/Helpers";
import { deleteToken, deleteUserData, getToken } from "../../../api/Account";
import NoData from "../../../components/NoData";
import { PaginationComponent } from "../../../components/PaginationComponent";
import { deleteIntCorrienteAsync, getInteresListAsync } from "../../../api/InteresCorriente";
import SmallModal from "../../../components/modals/SmallModal";
import AddTasaInteres from "./AddTasaInteres";
import { EditTasaInteres } from "./EditTasaInteres";
import Swal from "sweetalert2";
import { monoFont } from "../../../theme";

const MainInteresCorriente = () => {
  const [interesCorrienteList, setInteresCorrienteList] = useState([]);
  const [selectedIC, setSelectedIC] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [localReload, setLocalReload] = useState(false);

  const { access, setIsLoading, setIsLogged, setIsUnautorized } = useContext(DataContext);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getInteresListAsync(token);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setInteresCorrienteList(result.data.result);
    })();
  }, [localReload]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsperPage] = useState(10);
  const indexLast = currentPage * itemsperPage;
  const indexFirst = indexLast - itemsperPage;
  const currentItem = interesCorrienteList.slice(indexFirst, indexLast);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const deleteIC = async (item) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "No podras revertir esto...!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#2979ff",
      cancelButtonColor: "#f50057",

      confirmButtonText: "Eliminar!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);
          const result = await deleteIntCorrienteAsync(token, item.id);
          if (!result.statusResponse) {
            setIsLoading(false);

            if (result.error === "eX01") {
              deleteUserData();
              deleteToken();
              setIsLogged(false);
              return;
            }

            if (result.error === "Unauthorized") {
              setIsUnautorized(true);
              return;
            }
            simpleMessage(result.error, "error");
            return;
          }
          setIsLoading(false);
          setLocalReload(!localReload);

          Swal.fire("Eliminado!", "Tasa de Interes Eliminada.", "success");
        })();
      }
    });
  };

  return (
    <div>
      <Paper sx={{ overflow: "hidden" }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", borderBottom: "1px solid", borderColor: "divider" }}>
          <Typography sx={{ fontSize: 15, fontWeight: 600 }}>Tasas de interés corriente</Typography>
          {isAccess(access, "CONFIG CREATE") ? (
            <Button onClick={() => setShowModal(true)} variant="contained" color="primary" size="small" startIcon={<AddRoundedIcon sx={{ fontSize: 17 }} />}>
              Agregar
            </Button>
          ) : null}
        </Box>

        {isEmpty(currentItem) ? (
          <NoData />
        ) : (
          <Stack spacing={0}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Tasa de interés</TableCell>
                    {isAccess(access, "CONFIG UPDATE") || isAccess(access, "CONFIG DELETE") ? <TableCell align="center">Acciones</TableCell> : null}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {currentItem.map((row) => {
                    const { id, intCorriente } = row;
                    return (
                      <TableRow key={id}>
                        <TableCell sx={{ fontFamily: monoFont, color: "text.disabled" }}>{id}</TableCell>
                        <TableCell sx={{ fontFamily: monoFont, fontWeight: 600 }}>{`${intCorriente.toFixed(2)} %`}</TableCell>
                        {isAccess(access, "CONFIG UPDATE") || isAccess(access, "CONFIG DELETE") ? (
                          <TableCell align="center">
                            <Stack direction={"row"} spacing={0.5} justifyContent="center">
                              {isAccess(access, "CONFIG UPDATE") ? (
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    setSelectedIC(row);
                                    setShowEditModal(true);
                                  }}
                                >
                                  <EditRoundedIcon sx={{ fontSize: 17 }} />
                                </IconButton>
                              ) : null}
                              {isAccess(access, "CONFIG DELETE") ? (
                                <IconButton size="small" sx={{ color: "error.main" }} onClick={() => deleteIC(row)}>
                                  <DeleteRoundedIcon sx={{ fontSize: 17 }} />
                                </IconButton>
                              ) : null}
                            </Stack>
                          </TableCell>
                        ) : null}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ padding: "10px 20px 14px" }}>
              <PaginationComponent data={interesCorrienteList} paginate={paginate} itemsperPage={itemsperPage} />
            </Box>
          </Stack>
        )}
      </Paper>

      <SmallModal titulo={"Agregar Tasa de Interes"} isVisible={showModal} setVisible={setShowModal}>
        <AddTasaInteres setShowModal={setShowModal} localReload={localReload} setLocalReload={setLocalReload} />
      </SmallModal>

      <SmallModal titulo={`Editar Interes Corriente`} isVisible={showEditModal} setVisible={setShowEditModal}>
        <EditTasaInteres selected={selectedIC} setShowModal={setShowEditModal} localReload={localReload} setLocalReload={setLocalReload} />
      </SmallModal>
    </div>
  );
};

export default MainInteresCorriente;
